<div class="loading-message-wrapper">
  <h3 class="loading-message gradient-typing">
    <ng-container *ngFor="let word of characters; let i = index">
      <span *ngIf="word.trim().length > 0" [style.animationDelay]="(i * 0.1) + 's'">
        {{ word }}
      </span>
      <span *ngIf="word.trim().length === 0">&nbsp;</span>
    </ng-container>
  </h3>
</div>